/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { workloadIdentitiesListPlatforms } from "../funcs/workloadIdentitiesListPlatforms.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { WorkloadPlatformCatalog } from "../models/components/workloadplatformcatalog.js";
import {
  ListWorkloadPlatformsRequest,
  ListWorkloadPlatformsSecurity,
} from "../models/operations/listworkloadplatforms.js";
import { unwrapAsync } from "../types/fp.js";
export type WorkloadPlatformsQueryData = WorkloadPlatformCatalog;

export function prefetchWorkloadPlatforms(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListWorkloadPlatformsRequest | undefined,
  security?: ListWorkloadPlatformsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildWorkloadPlatformsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildWorkloadPlatformsQuery(
  client$: GramCore,
  request?: ListWorkloadPlatformsRequest | undefined,
  security?: ListWorkloadPlatformsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<WorkloadPlatformsQueryData>;
} {
  return {
    queryKey: queryKeyWorkloadPlatforms({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function workloadPlatformsQueryFn(
      ctx,
    ): Promise<WorkloadPlatformsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(workloadIdentitiesListPlatforms(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyWorkloadPlatforms(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "workloadIdentities", "listPlatforms", parameters];
}
